import moment from 'moment'

export const getFileNameCompanyReport = companyName =>
  `Reporte_${companyName}_${moment().format('MM-DD-YYYY')}.xlsx`
